(function () {
  'use strict';

  var CONVERSION_FACTOR = 0.877;

  function isFiniteNonNegative(value) {
    return Number.isFinite(value) && value >= 0;
  }

  function calculate(thca, delta9, massGrams, unit) {
    if (thca === '' || thca === null || typeof thca === 'undefined' ||
        delta9 === '' || delta9 === null || typeof delta9 === 'undefined') {
      throw new Error('Enter both the THCA and delta-9 THC values.');
    }
    var thcaValue = Number(thca);
    var delta9Value = Number(delta9);
    var massValue = massGrams === '' || massGrams === null || typeof massGrams === 'undefined'
      ? null
      : Number(massGrams);

    if (!isFiniteNonNegative(thcaValue) || !isFiniteNonNegative(delta9Value)) {
      throw new Error('Enter non-negative numbers for THCA and delta-9 THC.');
    }
    if (massValue !== null && !isFiniteNonNegative(massValue)) {
      throw new Error('Package weight must be a non-negative number.');
    }
    if (unit === 'percent' && (thcaValue > 100 || delta9Value > 100)) {
      throw new Error('Percent values cannot be greater than 100.');
    }
    if (unit === 'mg-g' && (thcaValue > 1000 || delta9Value > 1000)) {
      throw new Error('mg/g values cannot be greater than 1,000.');
    }

    var convertedThca = thcaValue * CONVERSION_FACTOR;
    var total = delta9Value + convertedThca;
    return {
      thca: thcaValue,
      delta9: delta9Value,
      convertedThca: convertedThca,
      total: total,
      massGrams: massValue,
      packageMilligrams: massValue === null
        ? null
        : total * (unit === 'percent' ? 10 : 1) * massValue
    };
  }

  function format(value, digits) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
  }

  function bind(root) {
    var form = root.querySelector('[data-ihf-calculator-form]');
    if (!form) return;

    var unitInputs = form.querySelectorAll('input[name="ihf-calculator-unit"]');
    var thcaInput = form.querySelector('[name="ihf-thca"]');
    var delta9Input = form.querySelector('[name="ihf-delta9"]');
    var massInput = form.querySelector('[name="ihf-mass"]');
    var labels = root.querySelectorAll('[data-unit-label]');
    var massRow = root.querySelector('[data-mass-row]');
    var result = root.querySelector('[data-calculator-result]');
    var error = root.querySelector('[data-calculator-error]');
    var totalOutput = root.querySelector('[data-total-output]');
    var formulaOutput = root.querySelector('[data-formula-output]');
    var packageRow = root.querySelector('[data-package-result]');
    var packageOutput = root.querySelector('[data-package-output]');

    function selectedUnit() {
      return form.querySelector('input[name="ihf-calculator-unit"]:checked').value;
    }

    function updateUnit() {
      var unit = selectedUnit();
      labels.forEach(function (label) {
        label.textContent = unit === 'percent' ? '%' : 'mg/g';
      });
      result.hidden = true;
      error.hidden = true;
    }

    unitInputs.forEach(function (input) {
      input.addEventListener('change', updateUnit);
    });

    form.addEventListener('reset', function () {
      window.setTimeout(updateUnit, 0);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      error.hidden = true;
      result.hidden = true;

      try {
        var unit = selectedUnit();
        var values = calculate(thcaInput.value, delta9Input.value, massInput.value, unit);
        var unitLabel = unit === 'percent' ? '%' : ' mg/g';
        totalOutput.textContent = format(values.total, 3) + unitLabel;
        formulaOutput.textContent =
          format(values.delta9, 3) + ' + (0.877 × ' + format(values.thca, 3) + ') = ' +
          format(values.total, 6) + unitLabel;

        if (values.packageMilligrams === null) {
          packageRow.hidden = true;
        } else {
          packageOutput.textContent = format(values.packageMilligrams, 1) + ' mg in the entered package mass';
          packageRow.hidden = false;
        }

        result.hidden = false;
        result.focus();
      } catch (calculatorError) {
        error.textContent = calculatorError.message;
        error.hidden = false;
        error.focus();
      }
    });

    updateUnit();
  }

  function init() {
    document.querySelectorAll('[data-ihf-thca-calculator]').forEach(bind);
  }

  window.IHFThcaCalculator = {
    calculate: calculate,
    conversionFactor: CONVERSION_FACTOR
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
